import { render, staticRenderFns } from "./AdminContactManagement.vue?vue&type=template&id=6c4f1391&scoped=true"
import script from "./AdminContactManagement.vue?vue&type=script&lang=js"
export * from "./AdminContactManagement.vue?vue&type=script&lang=js"
import style0 from "./AdminContactManagement.vue?vue&type=style&index=0&id=6c4f1391&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4f1391",
  null
  
)

export default component.exports